module.exports = __webpack_public_path__ + "media/ecom/quotes-fa1b6ccd.svg";